import api from '../utils/api';

// Email-template service. Two audiences, both owned by scale-be but now reached
// THROUGH cm-be's scale-proxy (case managers no longer carry a Supabase JWT, so
// they can't call scale-be directly). cm-be verifies the CM token, enforces the
// CM->mediator / CM-identity scope, then forwards to scale-be with the shared
// internal secret.
//
//   1. Case-manager templates: /scale-proxy/case-manager/:cmId/email-templates...
//   2. Per-mediator templates: /scale-proxy/mediators/:mediatorId/email-templates...

export const listCaseManagerTemplates = async (caseManagerId) => {
    const response = await api.get(
        `/scale-proxy/case-manager/${caseManagerId}/email-templates`,
    );
    return response?.data;
};

export const getCaseManagerTemplate = async (caseManagerId, slug) => {
    const response = await api.get(
        `/scale-proxy/case-manager/${caseManagerId}/email-templates/${slug}`,
    );
    return response?.data;
};

export const saveCaseManagerTemplate = async (caseManagerId, slug, payload) => {
    const response = await api.put(
        `/scale-proxy/case-manager/${caseManagerId}/email-templates/${slug}`,
        payload,
    );
    return response?.data;
};

export const resetCaseManagerTemplate = async (caseManagerId, slug) => {
    const response = await api.delete(
        `/scale-proxy/case-manager/${caseManagerId}/email-templates/${slug}`,
    );
    return response?.data;
};

export const sendCaseManagerTestEmail = async (
    caseManagerId,
    slug,
    testEmail,
    subject,
    bodyHtml,
) => {
    const response = await api.post(
        `/scale-proxy/case-manager/${caseManagerId}/email-templates/${slug}/test`,
        {
            test_email: testEmail,
            subject,
            body_html: bodyHtml,
        },
    );
    return response?.data;
};

// ============================================================
// Per-Mediator templates (case manager edits on the mediator's behalf).
// cm-be injects mediator_id when forwarding to scale-be, so callers don't
// pass it in the body/query anymore.
// ============================================================

export const listMediatorTemplates = async (mediatorId) => {
    const response = await api.get(
        `/scale-proxy/mediators/${encodeURIComponent(mediatorId)}/email-templates`,
    );
    return response?.data;
};

export const getMediatorTemplate = async (mediatorId, slug) => {
    const response = await api.get(
        `/scale-proxy/mediators/${encodeURIComponent(mediatorId)}/email-templates/${slug}`,
    );
    return response?.data;
};

export const saveMediatorTemplate = async (mediatorId, slug, payload) => {
    const response = await api.put(
        `/scale-proxy/mediators/${encodeURIComponent(mediatorId)}/email-templates/${slug}`,
        payload,
    );
    return response?.data;
};

export const resetMediatorTemplate = async (mediatorId, slug) => {
    const response = await api.delete(
        `/scale-proxy/mediators/${encodeURIComponent(mediatorId)}/email-templates/${slug}`,
    );
    return response?.data;
};

export const sendMediatorTestEmail = async (
    mediatorId,
    slug,
    testEmail,
    subject,
    bodyHtml,
) => {
    const response = await api.post(
        `/scale-proxy/mediators/${encodeURIComponent(mediatorId)}/email-templates/${slug}/test`,
        {
            test_email: testEmail,
            subject,
            body_html: bodyHtml,
        },
    );
    return response?.data;
};
